import React from 'react';
import { MDBDataTable } from 'mdbreact';
import dayjs from 'dayjs';
import { Button } from 'reactstrap';

const columns = [
  {
    label: 'Image',
    field: 'profilePicture',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Date of Joining',
    field: 'createdAt',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'District',
    field: 'district',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Buying Preferences',
    field: 'buyingPreferences',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const BuyersList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        data={{
          columns: columns,
          rows: props?.buyers?.map((x) => ({
            name: x.name,
            profilePicture: (
              <img
                src={x.profilePicture}
                className='rounded-circle avatar-sm card-img'
              />
            ),
            phone: x.phone,
            createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
            actions: (
              <Button color='info' onClick={() => props.editBuyer(x)}>
                View
              </Button>
            ),

            district: x.district?.name,
            buyingPreferences: x.vegetables?.map((x) => x.name).join(', '),
            // vegetables: x.vegetables.map((z) => z.name).join(', '),
          })),
        }}
      />
    </>
  );
};

export default BuyersList;
